import { render, staticRenderFns } from "./ButtonWithMaterialIcon.vue?vue&type=template&id=7eca1296&functional=true&"
var script = {}
import style0 from "./ButtonWithMaterialIcon.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ButtonWithMaterialIcon.vue?vue&type=custom&index=0&blockType=rb-button-with-material-icon&%3Adisabled=isDisabled&%40click=click"
if (typeof block0 === 'function') block0(component)

export default component.exports